import React, { memo } from "react"
import { isProject } from '@Utils/Functions'
import Image from 'next/image'
import { Listing } from 'shared-components'

const ProyectoIconImg = '/icons/proyecto-icon.png'
const DestacadoIconImg = '/icons/destacado-icon.png'
const TagIconImg = '/icons/tag-icon.png'
const BuildIconImg = '/icons/build-icon.png'

interface TagIconProps {
    property: Listing
    height?: number
    width?: number
}
const TagIcon = ({
    property,
    height = 14,
    width = 14,
}: TagIconProps) => {
    if (property.isMapFeatured) {
        if (property.isProject)
            return <Image src={ProyectoIconImg} width={height} height={width} />
        return <Image src={DestacadoIconImg} width={height} height={width} />
    }
    if (property.tag?.tag_label)
        return <Image src={TagIconImg} width={height} height={width} />
    return <Image src={BuildIconImg} width={height} height={width} />
}
export default memo(TagIcon)